
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M16.934 15.996a3.824 3.824 0 002.77-1.07 3.797 3.797 0 001.158-2.727 3.786 3.786 0 00-1.158-2.727 3.813 3.813 0 00-2.77-1.07h-.04a6.044 6.044 0 00-1.643-3.527A6.091 6.091 0 007.95 3.738a6.06 6.06 0 00-2.644 2.86h-.09c-1.25 0-2.45.494-3.334 1.376a4.692 4.692 0 000 6.646 4.724 4.724 0 003.335 1.377","fill":"#fff"}}),_c('path',{attrs:{"d":"M22.014 15.996a2.4 2.4 0 001.752-.664 2.384 2.384 0 00.543-2.653 2.385 2.385 0 00-1.351-1.296 2.4 2.4 0 00-.944-.154h-.025a3.8 3.8 0 00-1.038-2.205 3.823 3.823 0 00-4.576-.711 3.811 3.811 0 00-1.663 1.784h-.057c-.786 0-1.54.311-2.095.864a2.946 2.946 0 000 4.175 2.967 2.967 0 002.095.864","fill":"#D0E8F8"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.487 17.25a.5.5 0 11.866.5l-1.5 2.598a.5.5 0 01-.866-.5l1.5-2.598zm2.165 0a.5.5 0 01.866.5l-2 3.464a.5.5 0 11-.866-.5l2-3.464zm5.013-.183a.5.5 0 00-.683.183l-2 3.464a.5.5 0 00.866.5l2-3.464a.5.5 0 00-.183-.683zm-2.848.183a.5.5 0 01.866.5l-1 1.732a.5.5 0 01-.866-.5l1-1.732zm5.013-.183a.5.5 0 00-.683.183l-1 1.732a.5.5 0 00.866.5l1-1.732a.5.5 0 00-.183-.683z","fill":"#00AEEF"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    